import { navDB } from "./db";
import { transformModuleToRows } from "./transform";
import type { ModuleNode } from "./types";

export async function seedModule(moduleNode: ModuleNode) {
  const { nodes, items } = transformModuleToRows(moduleNode);

  await navDB.transaction("readwrite", navDB.navNodes, navDB.navItems, async () => {
    await navDB.navNodes.bulkPut(nodes);
    await navDB.navItems.bulkPut(items);
  });
}
